import React from 'react'
import init from './init'
import './style.scss'
import { SmoothScrollDummyScroll } from './utils/SmoothScrollManager'

class Background extends React.Component {
  $canvas: HTMLCanvasElement | null = null

  componentDidMount(): void {
    if (this.$canvas) {
      init({
        $canvas: this.$canvas,
        backgroundColor: 0x111111,
      })
    }
  }

  shouldComponentUpdate(): boolean {
    return false
  }

  render(): JSX.Element {
    return (
      <>
        <SmoothScrollDummyScroll />
        <canvas id="background" ref={(ref) => (this.$canvas = ref)} />
      </>
    )
  }
}

export default Background
